import React, { useContext, useState } from "react";
import { Modal } from "@clarkinc/zest-design-system";
import { InputGroup, Button, Icon } from "@clarkinc/zest-design-system/ui";
import { GroupProps } from "./GroupProps";
import FilterGroup from "./FilterGroup";
import setWindowLocationHref from "~/common/navigation/setWindowLocationHref";
import { addParamToUrl } from "./FilterUrlHelpers";
import { FilterModalContext } from "../FilterModalContextProvider";
import spritePath from "~/common/Icons/Zest/remixicon.symbol.v1.svg";
interface SearchWithinFilterProps extends GroupProps {
  inputId?: string;
}
const SearchWithinFilter = ({
  groups,
  toggleCollapsed,
  groupsWithMultipleSelections,
  pageUrl,
  inputId = "search_within"
}: SearchWithinFilterProps) => {
  const [searchString, setSearchString] = useState("");
  const [showError, setShowError] = useState(false);
  const showSearchWithinFilter = !pageUrl.includes("withinval=");
  const searchIndex = pageUrl.indexOf("?");
  const formSubmitUrl = searchIndex > 0 ? pageUrl.substring(0, pageUrl.indexOf("?")) : pageUrl;
  const {
    compareProductsActive,
    storedFilterUrl
  } = useContext(FilterModalContext);
  const shouldOpenModal = compareProductsActive && storedFilterUrl;
  const handleSubmit = async (event: React.SyntheticEvent) => {
    setShowError(false);
    event.preventDefault();
    const searchText = searchString.trim();
    if (searchText.length > 0) {
      const searchData = {
        searchWithinText: searchText,
        rawClientUrl: pageUrl
      };
      try {
        const request = await fetch(`/api/productlisting/searchwithinpage`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(searchData)
        });
        if (!request.ok) {
          throw new Error(`Failed to search within results, status: ${request.status}`);
        }
        const resultsFound: boolean = await request.json<boolean>();
        if (!resultsFound) {
          setShowError(true);
          return;
        }
        const updatedUrl = addParamToUrl(pageUrl, "withinval", searchText);
        if (shouldOpenModal) {
          Modal.open("confirm-edit-filters-warning");
          storedFilterUrl.current.url = updatedUrl;
        } else {
          setWindowLocationHref(updatedUrl);
        }
      } catch {
        // Do nothing
      }
    }
  };
  return showSearchWithinFilter ? <li className="bg-white border-gray-200 border-solid border-0 border-t mb-10 mt-px z-10 lt:my-0" data-sentry-component="SearchWithinFilter" data-sentry-source-file="SearchWithinFilter.tsx">
      <div id="collapseSearch" className="py-2-1/2 px-3-1/2 pb-3 lt:my-2 lt:py-0 lt:pl-3">
        <form className="flex" action={formSubmitUrl} method="get" id="searchWithinForm" onSubmit={handleSubmit}>
          <InputGroup theme="wss" inputSize="small" groupLabel="Search within results" color="white" hasError={showError} errorMessages="No results match this term" id={inputId} data-sentry-element="InputGroup" data-sentry-source-file="SearchWithinFilter.tsx">
            <div className="inline-flex flex-wrap items-center justify-between lt:block">
              <InputGroup.Label className="font-bold " data-sentry-element="unknown" data-sentry-source-file="SearchWithinFilter.tsx">
                Search Within Results
              </InputGroup.Label>
              <InputGroup.Wrapper className="w-44 pt-1" data-sentry-element="unknown" data-sentry-source-file="SearchWithinFilter.tsx">
                <InputGroup.Input value={searchString} onValueChange={value => {
                setSearchString(value);
              }} data-testid="search_within_input" data-sentry-element="unknown" data-sentry-source-file="SearchWithinFilter.tsx" />
                <Button theme="wss" type="submit" color="white" className="mt-0 px-2" data-testid="submit-button" data-sentry-element="Button" data-sentry-source-file="SearchWithinFilter.tsx">
                  <Icon name="ri-search-line" aria-hidden spriteSheetHref={spritePath} data-sentry-element="Icon" data-sentry-source-file="SearchWithinFilter.tsx" />
                </Button>
              </InputGroup.Wrapper>
            </div>
            <InputGroup.Error data-sentry-element="unknown" data-sentry-source-file="SearchWithinFilter.tsx" />
          </InputGroup>
        </form>
      </div>
    </li> : <>
      {groups.map(group => <FilterGroup {...{
      filterText: "withinval",
      group,
      toggleCollapsed,
      groupsWithMultipleSelections
    }} key={`searchWithinFilter-${group.groupNameEncoded}`} />)}
    </>;
};
export default SearchWithinFilter;